function addCacheBuster(url) {
    const result = new URL(url, document.baseURI);
    result.searchParams.set('nocache', Date.now());
    return result.href;
}

export default {
    name: 'auth',
    callable() {
        function isLoggedIn() {
            return document.querySelector("meta[name='FINN.userid']") != null;
        }

        return {
            isLoggedIn,

            redirect(target, options) {
                target = target || 'loginForm.html';
                options = options || {};
                const url = addCacheBuster(
                    options.redirectUrl || window.location.href
                );
                window.location = `/${target}?redirectTo=${encodeURIComponent(
                    url
                )}`;
            },

            logout(options) {
                options = options || {};
                options.redirectUrl = addCacheBuster(
                    options.redirectUrl || window.location.href
                );
                const logout = document.createElement('form');
                logout.method = 'post';
                logout.action = '/logout.html';
                document.body.appendChild(logout);
                logout.submit();
            },

            login(options) {
                if (!isLoggedIn()) {
                    this.redirect('loginForm.html', options);
                }
            },
        };
    },
};



// WEBPACK FOOTER //
// ./services/auth.js